module.exports = __webpack_public_path__ + "src/assets/images/logo-heropro-white.png?b876a3db2333b25d365b6cc7f48a331a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-heropro-white.png
// module id = 1018
// module chunks = 1